<template>
  <div id="contenedor-eliminar-auditoria">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Auditoría </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Auditoría? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{auditoria.ejercicio}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="auditoria.nombre">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoria"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixAuditorias from './mixAuditorias';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContenedorEliminarAuditoria',
  props: {
    auditoria: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixAuditorias],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoria() {
      this.enviandoFormulario = true;
      this.mixEliminarAuditoria();
    },
  },
  computed: {
    tieneDependencias() {
      return this.auditoria.informes.length > 0;
    },
  },
};
</script>
